import './TextInputInnerVisualSlot-4a14b955.css';

var styles = {"Spinner":"prc-components-Spinner-Azb7p","SpinnerLeading":"prc-components-SpinnerLeading-s-LyA","SpinnerHidden":"prc-components-SpinnerHidden-GG1PJ","SpinnerVisible":"prc-components-SpinnerVisible-w5g8l","Box":"prc-components-Box-QK3tG"};

export { styles as default };
